// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PRadarChartOutlinedSvg from "@fishx/icons-svg/es/asn/PRadarChartOutlined";
import FishxIcon from '../components/FishxIcon';

var PRadarChartOutlined = function PRadarChartOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PRadarChartOutlinedSvg
  }));
};

PRadarChartOutlined.displayName = 'PRadarChartOutlined';
export default React.forwardRef(PRadarChartOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PRadarChartOutlined.js
// module id = 3565
// module chunks = 0